import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthComponent, CoreComponent, CustomPreloadingStrategy, NotFoundComponent} from '@customcoding/core';
import {AuthGuard} from '@customcoding/shared';

const routes: Routes = [
	{
		path: '',
		component: CoreComponent,
		canActivate: [AuthGuard],
		children: [
			{
				path: 'employee',
				loadChildren: () => import('@customcoding/core').then(m => m.EmployeeModule),
			},
			{
				path: 'user',
				loadChildren: () => import('@customcoding/core').then(m => m.UserModule),
			},
			{
				path: 'company',
				loadChildren: () => import('@customcoding/core').then(m => m.CompanyModule),
			},
			{
				path: 'department',
				loadChildren: () => import('@customcoding/core').then(m => m.DepartmentModule),
			},
			{
				path: 'contact',
				loadChildren: () => import('@customcoding/core').then(m => m.ContactModule),
			},
			{
				path: 'page',
				loadChildren: () => import('@customcoding/core').then(m => m.PageModule),
			},
			{
				path: 'navigation',
				loadChildren: () => import('@customcoding/core').then(m => m.NavigationModule),
			},
			{
				path: 'dashboard',
				loadChildren: () => import('@customcoding/core').then(m => m.DashboardModule),
			},
			{
				path: 'settings',
				loadChildren: () => import('@customcoding/core').then(m => m.SettingsModule),
			},
			{
				path: 'icfaportal',
				loadChildren: () => import('./icfaportal/icfaportal.module').then(m => m.IcfaportalModule),
				data: {
					applyPreload: true
				}
			},
			{
				path: 'dashboard',
				redirectTo: 'dashboard',
				pathMatch: 'full',
			},
			{
            	path: '',
            	pathMatch: 'full',
            	redirectTo: 'dashboard',
            }
		]
	},
	{
		path: 'auth',
		component: AuthComponent,
		loadChildren: () => import('@customcoding/core').then(m => m.AuthModule)
	},
	{
    	path: 'external',
    	loadChildren: () => import('./external/external.module').then(m => m.ExternalModule)
    },
	{
        path: 'error',
        loadChildren: () => import('@customcoding/core').then(m => m.ErrorPagesModule)
    },
    {path: '**', redirectTo: '/error/404'},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {useHash: false, preloadingStrategy: CustomPreloadingStrategy})],
	exports: [RouterModule],
	providers: []
})
export class AppRoutingModule {
}


